import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorOrHttpExtensions } from '../../../results/error-or/Extensions/error-or.extensions';
import { ApiProblemDetails } from '../../../results/error-or/interfaces/problem-details.interface';

import { ErrorType } from '../../../results/error-or/enums/error-type.enum';
import { ErrorOrError } from '../../../results/error-or/models/error-or-error.model';
import { ToastService } from '../../../../../trash/shared/components/toasters/Toast.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    return next(req).pipe(
        catchError((httpErrorResponse: HttpErrorResponse) => {
            let apiProblemDetails: ApiProblemDetails | null = httpErrorResponse.error;

            if (!apiProblemDetails) {
                let error = ErrorOrHttpExtensions.toErrorOrError(httpErrorResponse.status);

                return throwError(() => [error]);
            }

            let errors = ErrorOrHttpExtensions.toErrorOrErrors(apiProblemDetails);

            if (apiProblemDetails.errors) {
                return throwError(() => errors);
            }

            return throwError(() => errors);
        })
    );
};

export function handleApiErrors(
    errors: ErrorOrError[],
    toastService: ToastService,
    customErrors: ErrorOrError[] = [],
    validationErrorsHandler: ((errors: ErrorOrError[]) => void) | undefined = undefined
): any {
    let firstError = errors[0];

    if (validationErrorsHandler && firstError.type == ErrorType.VALIDATION) {
        validationErrorsHandler(errors);
        return;
    }

    let error = customErrors.find(x => x.type == firstError.type);

    if (error) {
        showError(error, toastService);

        return;
    }

    toastService.showError(firstError?.code, firstError?.toErrorMessage());
}

function showError(error: ErrorOrError, toastService: ToastService) {
    toastService.showError(error.code, error.description);
}

export function createValidationError(
    code: string,
    description: string,
    field?: string // Make the field parameter optional
): ErrorOrError[] {
    const metadata = field ? { field } : undefined;
    const validationError = ErrorOrError.validation(code, description, metadata);

    // Return the error wrapped in an array for aggregation
    return [validationError];
}
